import { css } from '@emotion/react'

const S = {
  empty: css`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 16px;
    height: 100%;
    color: var(--Colors-Gray-700);
    padding: 24px;
    text-align: center;
    line-height: 1.5;

    p {
      display: flex;
      flex-direction: column;
      align-items: center;

      > span {
        display: flex;
        > svg {
          margin: 0 4px 0 6px;
        }
      }
    }
  `,
}

export default S
